import { UseMutationOptions, useMutation } from '@tanstack/react-query';

import { z } from 'zod';

import {
  PostTkv2CompsAPIError,
  PostTkv2CompsAPIVariables,
  fetchPostTkv2CompsAPI,
} from '../toolkitComponents.js';
import { useToolkitContext } from '../toolkitContext.js';
import { Registry } from './registry.js';

type Response = z.infer<typeof schResponse>;
const {
  schemas: { REQUEST: schRequest, RESPONSE: schResponse },
} = Registry.postTkv2CompsAPI;

export const usePostTkv2CompsAPI = (
  options?: Omit<
    UseMutationOptions<Response, PostTkv2CompsAPIError, PostTkv2CompsAPIVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useToolkitContext();

  return useMutation<Response, PostTkv2CompsAPIError, PostTkv2CompsAPIVariables>(
    (variables: PostTkv2CompsAPIVariables) =>
      fetchPostTkv2CompsAPI({
        ...fetcherOptions,
        ...variables,
        body: schRequest.BODY.parse(variables.body),
      }).then((r) => schResponse.parse(r)),
    options,
  );
};
